module.exports = __webpack_public_path__ + "img/new_face.b6f31cb5.svg";